import React from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import NewUserStory from "./NewUserStory";
import StoryList from "./StoryList";
import {
  addSuccessCriteria,
  clearSuccessCriteria,
  getOneUserStories,
  getUserStories,
  removeSuccessCriteria,
  saveUserStories,
  updateUserStories
} from "../../../actions/userStories";
import _ from "lodash-es";

class UserStories extends React.Component {
    constructor(props) {
        super(props);
        this.storyEditPage = this.storyEditPage.bind(this);
        this.lastUpdatedStory = this.lastUpdatedStory.bind(this);
        this.state = {
          loading: true
        }
    }

    async componentDidMount() {
      const projectId = this.props.sprint.project;
      const sprintId = this.props.sprint._id;
      await this.props.getUserStories(projectId, sprintId);
      this.setState({
        loading: false
      })
    }

    storyEditPage() {
        const {history, userStoriesList} = this.props;

        const editModes = ['addStory', 'editStory', 'duplicateStory'];
        return userStoriesList.length === 0
            || editModes.includes(history.location.state);
    }

    lastUpdatedStory() {
        const {history, userStoriesList} = this.props;
        let lastSavedStoryId = undefined;
        if (history.location && history.location.state === 'listStories') {
            lastSavedStoryId = history.location && history.location.state && history.location.state.storyId;
        }
        return lastSavedStoryId === undefined ? userStoriesList[userStoriesList.length - 1]._id : lastSavedStoryId
    }

    render() {
        const {userStoriesList, jumpToStep, history, sprint, sprintSavedData} = this.props;
        const projectId = sprint.project;
        const sprintId = sprint._id;

        return (
          <>
          {
            !this.state.loading &&
            <div>
            {
              this.storyEditPage()
            ? <NewUserStory projectId={this.props.projectId} />
            : <StoryList
                userStories={userStoriesList}
                projectId={projectId}
                sprintId={sprintId}
                history={history}
                lastUpdatedStoryId={this.lastUpdatedStory()}
              />
            }
            </div>
          }
          </>
        )
    }
}


  const mapStateToProps = state => ({
    projectSavedData: state.project.projectSavedData,
    sprintSavedData: state.sprint.sprintSavedData,
    successCriteriaData: state.userStories.successCriteria,
    userStoriesSavedData: state.userStories.userStoriesSavedData,
    userStoriesList: state.userStories.userStoriesList,
    userStoriesUpdateData: state.userStories.userStoriesUpdateData,
    userStoryFetchResponse: state.userStories.oneUserStoriesList
  });

  const mapDispatchToProps = dispatch => ({
    createNewUserStory: (data, projectId, sprintId) =>
      dispatch(saveUserStories(data, projectId, sprintId)),
    addSuccessCriteria: data => dispatch(addSuccessCriteria(data)),
    removeSuccessCriteria: val => dispatch(removeSuccessCriteria(val)),
    clearSuccessCriteria: () => dispatch(clearSuccessCriteria()),

    getUserStories: (projectId, sprintId) =>
      dispatch(getUserStories(projectId, sprintId)),
    getOneUserStories: (projectId, sprintId, storyId) =>
      dispatch(getOneUserStories(projectId, sprintId, storyId)),
    updateUserStories: (data, projectId, sprintId, storyId, callback) =>
      dispatch(updateUserStories(data, projectId, sprintId, storyId, callback))
  });


export default connect(mapStateToProps, mapDispatchToProps, null)(withRouter(UserStories));